import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, NavLink, Navigate } from 'react-router-dom';
import VolCurveView from './views/VolCurveView';
import VolArbView from './views/VolArbView';
import './App.css';

function App() {
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    document.body.classList.toggle('dark-mode', darkMode);
  }, [darkMode]);

  return (
    <BrowserRouter>
      <div className="app">
        <header className="header">
          <div className="header-left">
            <h1 className="logo">Crypto Trading</h1>
            <nav className="nav">
              <NavLink
                to="/vol-curve"
                className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
              >
                Vol Curve
              </NavLink>
              <NavLink
                to="/vol-arb"
                className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
              >
                Vol Arb
              </NavLink>
            </nav>
          </div>
          <div className="header-actions">
            <button
              onClick={() => setDarkMode(!darkMode)}
              className="theme-toggle"
              title={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
            >
              {darkMode ? '\u2600\uFE0F' : '\uD83C\uDF19'}
            </button>
          </div>
        </header>
        <main className="main">
          <Routes>
            <Route path="/" element={<Navigate to="/vol-curve" replace />} />
            <Route path="/vol-curve" element={<VolCurveView />} />
            <Route path="/vol-arb" element={<VolArbView />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
